import {mutations} from "./mutations";
import {actions} from "./actions";
import {getters} from "./getters";

const state = {
    firmas: [],
    errorFirmas: false,
    loadingFirmas: false
}

const firmasModule = {
    state,
    mutations,
    actions,
    getters
}

export default firmasModule;